module.exports = __webpack_public_path__ + "img/D-faq-icon.c7bc651a.svg";